// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{font-style:normal;color:#fff;background-color:#000517;font-size:16px;line-height:27px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
